"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

var _Button = _interopRequireDefault(require("../Button/Button"));

require("./Dropdown.css");

var _DropdownTrigger = _interopRequireDefault(require("./DropdownTrigger"));

var _DropdownContent = _interopRequireDefault(require("./DropdownContent"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
Dropdown without state, for when it needs to be controlled from outside
*/
function DropdownDumb(_ref) {
  var arrow = _ref.arrow,
      className = _ref.className,
      margin = _ref.margin,
      componentRef = _ref.componentRef,
      open = _ref.open,
      color = _ref.color,
      trigger = _ref.trigger,
      children = _ref.children,
      position = _ref.position,
      disabled = _ref.disabled,
      padding = _ref.padding,
      onToggle = _ref.onToggle,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["arrow", "className", "margin", "componentRef", "open", "color", "trigger", "children", "position", "disabled", "padding", "onToggle"]);

  var cssClasses = ['st_dropdown'];
  if (open) cssClasses.push('st_dropdown--open');
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    cssClasses: cssClasses
  });

  if (trigger) {
    return /*#__PURE__*/_react["default"].createElement("div", _extends({
      className: cssClasses.join(' ')
    }, otherProps, {
      ref: componentRef
    }), /*#__PURE__*/_react["default"].createElement(_DropdownTrigger["default"], {
      componentEl: _Button["default"],
      tertiary: true,
      color: color,
      onClick: onToggle,
      "aria-haspopup": "true",
      "aria-expanded": !!open,
      disabled: disabled
    }, trigger), open && /*#__PURE__*/_react["default"].createElement(_DropdownContent["default"], {
      arrow: arrow,
      open: open,
      position: position,
      padding: padding
    }, children));
  } // if trigger prop is missing, we are in subcomponent land
  // attach props to Dropdown.Trigger and Dropdown.Content
  // which should both exist for this mode to work


  var requiredComponents = ['Dropdown.Trigger', 'Dropdown.Content'];

  var childrenWithProps = _react["default"].Children.map(children, function (child) {
    if (!_react["default"].isValidElement(child)) {
      return null;
    }

    var cloneParams = {};

    if (child.type.displayName === 'Dropdown.Trigger') {
      cloneParams.open = open;
      cloneParams.disabled = child.props.disabled || disabled;
      cloneParams.onClick = onToggle;
      requiredComponents.splice(requiredComponents.indexOf(child.type.displayName), 1);
    }

    if (child.type.displayName === 'Dropdown.Content') {
      cloneParams.open = open;
      cloneParams.padding = child.props.padding || padding;
      cloneParams.position = child.props.position || position;
      requiredComponents.splice(requiredComponents.indexOf(child.type.displayName), 1);
    }

    return _react["default"].cloneElement(child, cloneParams);
  });

  if (requiredComponents.length > 0) {
    // eslint-disable-next-line no-console
    console.warn("\n      The Dropdown component can't render because instances of " + requiredComponents.join(', ') + " are missing in the children\n    ");
  }

  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: cssClasses.join(' ')
  }, otherProps, {
    ref: componentRef
  }), childrenWithProps);
}

DropdownDumb.propTypes = {
  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** margin for box, if any */
  margin: utils.spacing.marginProps,

  /** whether dropdown is open */
  open: _propTypes["default"].bool,

  /** label for dropdown trigger.
  Omit to have full control via Dropdown.Trigger + Dropdown.Content */
  trigger: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** position of dropdown content */
  position: _propTypes["default"].oneOf(['left', 'right', 'left-flush', 'right-flush', 'none', 'none-horizontal', 'center']),

  /** display a pointy arrow on one of the side */
  arrow: _propTypes["default"].oneOf(['top-left', 'top-right', 'top']),

  /** color of dropdown trigger */
  color: _propTypes["default"].oneOf(['blurple', 'gray']),

  /** padding for content. Overrides default */
  padding: utils.spacing.paddingProps,

  /** whether control should be disabled */
  disabled: _propTypes["default"].bool,

  /** event listener for when dropdown is toggled; passes open state as parameter */
  onToggle: _propTypes["default"].func,

  /** ref for dropdown component */
  componentRef: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].shape({
    current: _propTypes["default"].any
  })])
};
DropdownDumb.defaultProps = {
  arrow: null,
  className: null,
  margin: null,
  open: false,
  position: 'left',
  color: 'blurple',
  padding: {
    vertical: 'smd',
    horizontal: 'md'
  },
  trigger: null,
  disabled: false,
  onToggle: function onToggle() {
    return null;
  },
  componentRef: null
};
var _default = DropdownDumb;
exports["default"] = _default;